import { useLayoutEffect, useState } from "react";

const fit = (fixedWidth) => fixedWidth || (typeof window === "undefined" ? 0 : Math.min(window.innerWidth, (window.innerHeight * 16) / 9));

export const Stage = ({ children, fixedWidth, className = "", testId }) => {
  const [w, setW] = useState(() => fit(fixedWidth));
  useLayoutEffect(() => {
    if (fixedWidth) { setW(fixedWidth); return undefined; }
    const onResize = () => setW(fit());
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [fixedWidth]);
  const stage = (
    <div className={`stage scanlines ${className}`} data-testid={testId} style={{ width: w, height: (w * 9) / 16, fontSize: w / 100 }}>
      {children}
    </div>
  );
  return fixedWidth ? stage : <div className="stage-wrap">{stage}</div>;
};
